import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const MatchDescriptionModuleAsyncComponent = AsyncComponent(async () => import('./match-description-module' /* webpackChunkName: "match-description-module" */ ));

export const MatchDescriptionModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <MatchDescriptionModuleAsyncComponent {...props}/>
  </React.Suspense>
}
